// extracted by mini-css-extract-plugin
export default {"wrap":"SearchMenuInputModal_wrap__7v5d3","searchInput":"SearchMenuInputModal_searchInput__HnpwZ"};